import { render, staticRenderFns } from "./NewsFilter.vue?vue&type=template&id=53c25845&scoped=true"
import script from "./NewsFilter.vue?vue&type=script&lang=js"
export * from "./NewsFilter.vue?vue&type=script&lang=js"
import style0 from "./NewsFilter.vue?vue&type=style&index=0&id=53c25845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c25845",
  null
  
)

export default component.exports